const API_BASE = process.env.REACT_APP_API_URL || '';

export async function createFleetExport(orgId, filters = {}) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/exports/fleet`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({ filters })
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to export fleet data');
    }
    throw new Error('Failed to create export');
  }
  
  const data = await response.json();
  return data.exportJob;
}

export async function getExportStatus(orgId, exportId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/exports/${exportId}/status`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Export not found');
    }
    throw new Error('Failed to get export status');
  }
  
  const data = await response.json();
  return data.exportJob;
}

export async function downloadArtifact(orgId, artifactId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/artifacts/${artifactId}/download`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Artifact not found');
    }
    throw new Error('Failed to download artifact');
  }
  
  const blob = await response.blob();
  const checksum = response.headers.get('X-Checksum');
  const contentDisposition = response.headers.get('Content-Disposition');
  let filename = 'export.csv';
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="(.+)"/);
    if (match) filename = match[1];
  }
  
  return { blob, filename, checksum };
}

export function triggerDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export async function createUptimeExport(orgId, filters = {}) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/exports/uptime`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(filters)
  });
  
  if (!response.ok) {
    if (response.status === 400) {
      throw new Error('From and to dates are required');
    }
    throw new Error('Failed to create uptime export');
  }
  
  const data = await response.json();
  return data.exportJob;
}
